require("bigtext/dist/bigtext");

export const initBigText = function(md) {

    return false;

    if (md.phone()) {


        $('.image-slider__title').bigtext({
            maxfontsize: 60,
            minfontsize: 18
        });
        $('.image-slider__sub-title').bigtext({
            maxfontsize: 18,
            minfontsize: 12
        });
    } else if (md.tablet()) {
        $('.image-slider__title').bigtext({
            maxfontsize: 80,
            minfontsize: 18
        });
        $('.image-slider__sub-title').bigtext({
            maxfontsize: 24,
            minfontsize: 12
        });
    } else {
        $('.image-slider__title').bigtext({
            maxfontsize: 130,
            minfontsize: 18
        });
        $('.image-slider__sub-title').bigtext({
            maxfontsize: 50,
            minfontsize: 14
        });
    }
};